import { useState, useRef, useEffect, forwardRef, useImperativeHandle } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { Paper, Box, CircularProgress, Typography  } from "@mui/material";


const ControlCircularProgressBar = forwardRef((props, ref) => {
    let { initialTime } = props; // in seconds
    const [timeLeft, setTimeLeft] = useState(initialTime);
    const [isLoading, setIsLoading] = useState(true);
    const [progressBarPercent, setProgressBarPercent] = useState(0);
    const timerId = useRef();
    const isUseCircularProgress = true; // CircularProgress 사용 여부   

    useImperativeHandle(ref, () => ({
        // 부모 컴포넌트에서 사용할 함수를 선언
        showTimer,
        hideTimer
    }));

    const showTimer = (newInitialTime) => {
        setIsLoading(true);
        setProgressBarPercent(0);
        initialTime = newInitialTime;
        setTimeLeft(newInitialTime);

        if (initialTime) {
            timerId.current = window.setInterval(() => {
                setTimeLeft((prevProgress) => prevProgress - 1);
            }, 1000);

            return () => {
                clearInterval(timerId.current);
            };
        }
    };

    const hideTimer = () => {
        setIsLoading(false);
        setProgressBarPercent(100);
        setTimeLeft(0);
    };
    

    useEffect(() => {
        if (initialTime) {
            timerId.current = window.setInterval(() => {
                setTimeLeft((prevProgress) => prevProgress - 1);
            }, 1000);

            return () => {
                clearInterval(timerId.current);
            };
        }
    }, []);

    useEffect(() => {
        if (initialTime > 0) {
            if (progressBarPercent < 100) {
                let updateProgressPercent = Math.round(
                    ((initialTime - (timeLeft - 1)) / initialTime) * 100
                );
                setProgressBarPercent(updateProgressPercent);
            }

            if (timeLeft === 0 && timerId.current) {
                clearInterval(timerId.current);
                setIsLoading(false);
                setProgressBarPercent(100);
                return;
            }
        }
    }, [timeLeft]);


    return (
        <Paper
            sx={{ position: "absolute",  
                top: 0, left: 0,
                width: "100%", height: "100%",
                justifyContent: "center", verticalAlign:"middle", alignItems: "center",  
                zIndex: 1,
                backgroundColor: "rgba(255, 255, 255, 0.4)",
                display: isLoading ? "block" : "none",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                    maxWidth: "100%",
                    margin: "0 auto",
                    padding: "20px",
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    //boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.15)",
                }}
            >
                {isUseCircularProgress ?
                <CircularProgress color="#f03e1f"  size={80} thickness={7} sx={{ color: '#f03e1f' }}/>
                :
                <Box sx={{ position: "relative", display: "inline-flex" }}>
                    <CircularProgress
                        variant="determinate"
                        size="16rem"
                        value={progressBarPercent}
                        sx={{
                            color: progressBarPercent > 90 ? `red` : "blue",
                            zIndex: 1,
                        }}
                    />

                    <Box
                        sx={{
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            position: "absolute",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 1,
                        }}
                    >
                        <Typography sx={{ fontWeight: 400, fontSize: "22px" }}>
                            Time left:
                        </Typography>
                        <Typography sx={{ fontWeight: 700, fontSize: "22px", ml: 1 }}>
                            {moment
                                .utc(1000 * timeLeft)
                                .format(
                                    `${timeLeft > 3600 ? "HH[h]:mm[m]:ss[s]" : "mm[m]:ss[s]"} `
                                )}
                        </Typography>
                    </Box>
                </Box>
                }
            </Box>
        </Paper>
    );
});

ControlCircularProgressBar.propTypes = {
    initialTime: PropTypes.number.isRequired, // in seconds
};

export default ControlCircularProgressBar;